import React from 'react';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
  alpha,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

type NavGroup = {
  id?: string;
  navlabel?: boolean;
  subheader?: string;
  title?: string;
  icon?: React.ElementType;
  href?: string;
  external?: boolean;
  disabled?: boolean;
  onClick?: React.MouseEvent<HTMLButtonElement, MouseEvent>;
};

interface ItemType {
  item: NavGroup;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  pathDirect: string;
}

const ListItemStyled = styled(ListItem)(({ theme }) => ({
  padding: 0,
  '& .MuiButtonBase-root': {
    marginBottom: 8,
    padding: '8px 16px',
    borderRadius: 8,
    whiteSpace: 'nowrap',
    backgroundColor: 'transparent',
    color: theme.palette.text.primary,
    transition: 'all 0.2s',
    fontWeight: 500,
    fontSize: '1rem',
    minHeight: 44,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.primary.contrastText,
      '& .MuiListItemIcon-root': {
        color: theme.palette.primary.contrastText,
      },
    },
    '&.Mui-selected, &.Mui-selected:hover': {
      color: theme.palette.primary.main,
      backgroundColor: alpha(theme.palette.primary.main, 0.14),
      '& .MuiListItemIcon-root': {
        color: theme.palette.primary.main,
      },
    },
    '&.Mui-disabled': {
      color: theme.palette.text.disabled,
    },
  },
}));

const NavItem = ({ item, pathDirect, onClick }: ItemType) => {
  const Icon = item.icon;
  const itemIcon = Icon ? <Icon stroke={1.5} size="1.3rem" /> : null;

  return (
    <List component="div" disablePadding key={item.id}>
      <ListItemStyled>
        <ListItemButton
          component={RouterLink}
          to={item.href || '#'}
          disabled={item.disabled}
          selected={pathDirect === item.href}
          target={item.external ? '_blank' : undefined}
          onClick={onClick}
          aria-current={pathDirect === item.href ? 'page' : undefined}
        >
          {itemIcon && (
            <ListItemIcon
              sx={{
                minWidth: 36,
                color: 'inherit',
                p: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {itemIcon}
            </ListItemIcon>
          )}
          <ListItemText
            primary={item.title}
            primaryTypographyProps={{
              fontWeight: 500,
              fontSize: '1rem',
              color: 'inherit',
            }}
          />
        </ListItemButton>
      </ListItemStyled>
    </List>
  );
};

export default NavItem;
